import { render, staticRenderFns } from "./WidgetBookingPassenger.vue?vue&type=template&id=99cf4dce&scoped=true"
import script from "./WidgetBookingPassenger.vue?vue&type=script&lang=js"
export * from "./WidgetBookingPassenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf4dce",
  null
  
)

export default component.exports